var _g, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileshare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "50,31.89 50,35.554 58.114,35.554 58.114,26.712 39.507,9.909 5.368,9.909 5.368,68.532  37.828,68.532 37.828,61.204 13.482,61.204 13.482,17.237 33.77,17.237 33.77,31.89  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M94.632,56.025L76.024,39.223h-34.14v58.623h52.747V56.025z M50,90.518V46.55h20.287v14.654h16.23v29.313 H50z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M74.303,19.812c-4.076-4.436-12.357-3.745-18.083,1.512l3.136,3.416c3.369-3.093,8.367-3.574,10.704-1.033 c1.698,1.852,1.829,4.661,0.644,7.212l-4.771,0.2l2.581,2.812l3.137,3.416l0.553,0.602l8.095-7.431l-4.243,0.177 C77.394,26.748,76.887,22.627,74.303,19.812z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M24.48,73.613l-3.479-3.266l-0.615-0.578l-7.208,7.683l4.185-0.338c-0.897,3.965,0.055,8.027,2.924,10.72 c4.523,4.244,12.655,3.239,17.752-2.195l-3.479-3.265c-3,3.196-7.903,3.865-10.495,1.436c-1.884-1.77-2.322-4.549-1.422-7.126 l4.705-0.382L24.48,73.613z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileshare);
export default __webpack_public_path__ + "static/media/fileshare.3a37d5224e80238b5d53e9035af5ccdd.svg";
export { ForwardRef as ReactComponent };